import React, { Component } from 'react';
import './styles.css'

class Header extends Component {

    render() {
        return (
            <div className='header-widget'>
                GADGET IN REACT
            </div>
        )
    }
}

export default Header;